// App.js - WEB
import React, { Component } from "react";
import { StyleSheet, Dimensions } from "react-native";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Header from "./header";
import { styles, updateDimensions } from "./styles";
import Footer from "./footer";
var blueBgPaddingLeft = 70;

class Tos extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    handleNameInput = (event) => {
        event.preventDefault();
        this.setState({
            name: event.target.value,
        });
    };
    handleEmailInput = (event) => {
        event.preventDefault();
        this.setState({
            email: event.target.value,
        });
    };
    updateDimensions() {
        updateDimensions();
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));

        this.loadTermly("https://app.termly.io/embed-policy.min.js", () => { });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillMount() {
        this.updateDimensions();
    }

    loadTermly(fileSrc, callback) {
        // Create a new script element
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = fileSrc;

        // Call a function (i.e., callback) once the script has been fully loaded
        script.onload = function () {
            callback();
        };

        // Insert the created script element before an existing script in the head
        document.head.insertBefore(script, document.head.firstChild);
    }

    MainPage() {
        return (
            <div className="AboutUsContainer">
                {/* Header Goes Here */}
                <Header />

                {/* How */}
                <div
                    className="AboutContainer"
                    style={{
                        width: "100%",
                        paddingLeft: blueBgPaddingLeft,
                        justifyContent: "center",
                        marginBottom: 50,
                        paddingTop: 80,
                    }}>
                    <Row style={{ width: "100%", paddingTop: 30 }}>
                        <Col md="12">
                            <div name="termly-embed" data-id="bf3037f0-e952-46c3-bd57-b253c8ca76b0" data-type="iframe"></div>

                            {/* <h1>Terms and Conditions of Use</h1>
                    <br></br>
                    <h2>1. Terms</h2>
                    <p>By accessing this Chrome Extension, accessible from https://addy-ai.web.app, you are agreeing to be bound by these Application Terms and Conditions of Use and agree that you are responsible for the agreement with any applicable local laws. If you disagree with any of these terms, you are prohibited from accessing this site. The materials contained in this Website are protected by copyright and trade mark law.</p>
                    <h2>2. Use License</h2>
                    <p>Permission is granted to temporarily download one copy of the materials on Addy.ai's Website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
                    <ul>
                        <li>modify or copy the materials;</li>
                        <li>use the materials for any commercial purpose or for any public display;</li>
                        <li>attempt to reverse engineer any software contained on Addy.ai's Website;</li>
                        <li>remove any copyright or other proprietary notations from the materials; or</li>
                        <li>transferring the materials to another person or "mirror" the materials on any other server.</li>
                    </ul>

                    <p>This will let Addy.ai to terminate upon violations of any of these restrictions. Upon termination, your viewing right will also be terminated and you should destroy any downloaded materials in your possession whether it is printed or electronic format.</p>
                    <h2>3. Disclaimer</h2>

                    <p>All the materials on Addy.ai's Website and Chrome Extension are provided "as is". Addy.ai makes no warranties, may it be expressed or implied, therefore negates all other warranties. Furthermore, Addy.ai does not make any representations concerning the accuracy or reliability of the use of the materials on its Website or otherwise relating to such materials or any sites linked to this Website.</p>
                    <h2>4. Limitations</h2>

                    <p>Addy.ai or its suppliers will not be held accountable for any damages that will arise with the use or inability to use the materials on Addy.ai's Website, even if Addy.ai or an authorize representative of this Website has been notified, orally or written, of the possibility of such damage. Some jurisdiction does not allow limitations on implied warranties or limitations of liability for incidental damages, these limitations may not apply to you.</p>
                    <h2>5. Revisions and Errata</h2>

                    <p>The materials appearing on Addy.ai's Website may include technical, typographical, or photographic errors. Addy.ai will not promise that any of the materials in this Website are accurate, complete, or current. Addy.ai may change the materials contained on its Website at any time without notice. Addy.ai does not make any commitment to update the materials.</p>

                    <h2>6. Links</h2>
                    <p>Addy.ai has not reviewed all of the sites linked to its Website and is not responsible for the contents of any such linked site. The presence of any link does not imply endorsement by Addy.ai of the site. The use of any linked website is at the user's own risk.</p>
                    
                    <h2>7. Site Terms of Use Modifications</h2>
                    <p>Addy.ai may revise these Terms of Use for its Website at any time without prior notice. By using this Website, you are agreeing to be bound by the current version of these Terms and Conditions of Use.</p>

                    <h2>8. Your Privacy</h2>
                    <p>Please read our Privacy Policy.</p>

                    <h2>9. Governing Law</h2>
                    <p>Any claim related to Addy.ai's Website shall be governed by the laws of us without regards to its conflict of law provisions.</p>
                    <br></br>
                    <h2>Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, You can contact us:</p>
                    <ul>
                    <li>By email: <a href="mailto:mvandi.yt@gmail.com">mvandi.yt@gmail.com</a></li>
                    </ul> */}
                        </Col>
                    </Row>
                </div>

                <Footer />
            </div>
        );
    }

    render() {
        return <div style={{ height: "100vh" }}>{this.MainPage()}</div>;
    }
}

export default Tos;
